import { render, staticRenderFns } from "./RosterManagement.vue?vue&type=template&id=89b6e784&scoped=true&"
import script from "@/views/RosterManagement/RosterManagement.ts?vue&type=script&lang=ts&"
export * from "@/views/RosterManagement/RosterManagement.ts?vue&type=script&lang=ts&"
import style0 from "@/views/RosterManagement/roster-management.scss?vue&type=style&index=0&id=89b6e784&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89b6e784",
  null
  
)

export default component.exports